import { render, staticRenderFns } from "./DirectAccessDenied.vue?vue&type=template&id=1f1e2dc8&"
import script from "./DirectAccessDenied.vue?vue&type=script&lang=js&"
export * from "./DirectAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports